var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.359,
    height: 20.743,
    viewBox: "0 0 32.359 20.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(-1291 -301.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8208",
    "data-name": "Path 8208",
    d: "M-219.354-141.675h29.04a1.659,1.659,0,0,1,1.659,1.659v17.424a1.659,1.659,0,0,1-1.659,1.659h-29.04a1.659,1.659,0,0,1-1.659-1.659v-17.424A1.659,1.659,0,0,1-219.354-141.675Z",
    transform: "translate(1512.013 442.932)",
    fill: "#0a4693"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8209",
    "data-name": "Path 8209",
    d: "M-147.82-48.952l1.386-8.119h2.215l-1.39,8.119Zm10.21-7.944a5.684,5.684,0,0,0-1.983-.34c-2.186,0-3.73,1.1-3.742,2.68-.012,1.166,1.1,1.817,1.942,2.207.859.4,1.149.651,1.145,1,0,.543-.689.792-1.323.792a4.633,4.633,0,0,1-2.083-.427l-.286-.129-.311,1.817a6.94,6.94,0,0,0,2.464.431c2.327,0,3.837-1.087,3.854-2.775.008-.925-.581-1.626-1.859-2.207-.772-.378-1.249-.626-1.245-1.008,0-.336.4-.7,1.269-.7a4.032,4.032,0,0,1,1.655.311l.2.1.3-1.755m5.7-.174h-1.709a1.1,1.1,0,0,0-1.157.672l-3.29,7.443h2.323s.382-1,.465-1.22l2.833,0c.066.286.27,1.216.27,1.216h2.054l-1.788-8.115Zm-2.713,5.244.884-2.269c-.012.021.183-.469.295-.776l.149.7s.423,1.937.514,2.344ZM-149.7-57.071l-2.166,5.538-.232-1.124a6.316,6.316,0,0,0-3.066-3.406l1.983,7.1,2.344,0,3.485-8.106-2.348,0",
    transform: "translate(1450.982 364.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8210",
    "data-name": "Path 8210",
    d: "M-183.3-54.97h-3.568l-.029.17a7.332,7.332,0,0,1,5.377,4.248l-.776-3.734a.924.924,0,0,0-1-.685",
    transform: "translate(1480.395 362.574)",
    fill: "#f2ae13"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.83c702dc4a651efa1973f9b9bea003b5.svg";
export { ForwardRef as ReactComponent };